import type { Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import CMSReference from './CMSReference';

const CMSReferences: React.FC<{ references?: Reference[] }> = ({ references }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {references?.map((ref) => (
      <CMSReference key={ref.uid} {...ref} />
    ))}
  </>
);

export default CMSReferences;
